<template>
  <div>
    <StatusHeader />

    <div class="registration-view">
      <div class="container mx-auto px-4 py-8">
        <h1 class="text-3xl font-bold text-center mb-8">Document Resubmission</h1>
        <div class="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6">
          <!-- Required Documents List from Status -->
          <div class="bg-orange-50 border-2 border-orange-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 mb-6">
            <h3 class="font-bold text-orange-800 mb-3 sm:mb-4 text-base sm:text-lg">
              Required Documents:
            </h3>
            <ul class="text-sm sm:text-base text-orange-700 space-y-1 sm:space-y-2">
              <li v-for="doc in displayRequiredDocuments" :key="doc">• {{ doc }}</li>
            </ul>
          </div>

          <!-- Document Upload Component -->
          <TutorDocumentsAndTerms
            :tutor-data="undefined"
            :initial-documents="{}"
            :initial-agreements="{}"
            :required-docs="requiredDocsKeys"
            :is-resubmission="true"
            @registration-complete="handleSubmit"
            @go-back="goBack"
            @data-changed="onDataChanged"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import StatusHeader from '@/components/StatusHeader.vue';
import TutorDocumentsAndTerms from '@/components/TutorDocumentsAndTerms.vue';

const router = useRouter();
const route = useRoute();

// Document mapping (same as TutorApplicationStatus.vue)
const documentNameMapping: Record<string, string> = {
  transcript: "Official Transcript of Grades",
  certificateOfGrade: "Certificate of Grade",
  diploma: "Diploma",
  governmentId: "Government Issued ID",
  curriculumVitae: "Curriculum Vitae",
  clearance: "Clearance",
  videoIntroduction: "Video Introduction",
  signedContract: "Signed Contract"
};

// Parse required documents from query params
const requiredDocsKeys = computed(() => {
  const csv = route.query.requiredDocs as string | undefined;
  if (!csv) return undefined;
  return csv.split(',').map(k => k.trim()).filter(Boolean);
});

// Display friendly document names (same as TutorApplicationStatus.vue)
const displayRequiredDocuments = computed(() => {
  const docs = requiredDocsKeys.value;
  if (!docs || !docs.length) {
    return [
      "Official academic transcript (high resolution PDF or image)",
      "Valid government-issued ID",
      "Certificate of enrollment or graduation",
      "Optional: Letter of recommendation from academic institution"
    ];
  }
  return docs.map(key => documentNameMapping[key] || key);
});

function handleSubmit(data: any) {
  router.push('/tutor/application-status');
}

function goBack() {
  router.push('/tutor/application-status');
}

function onDataChanged(data: any) {
  // Handle data changes if needed
}
</script>

<style scoped>
.registration-view {
  width: 100%;
  min-height: 100vh;
  background: url("/tutor-bg.png") center top/100% auto no-repeat;
  background-attachment: fixed;
  padding-top: 120px;
}
</style>